// extracted by mini-css-extract-plugin
module.exports = {"pinStar":"Pins_pinStar__1h6pJ"};